export default __webpack_public_path__ + "static/media/delete-svg-black.4dda0356.svg";